const NO_RESULTS_GROUPS_KEY = 'PricersEnabledNoResultsGroups';

export {
    NO_RESULTS_GROUPS_KEY
}